export const openidConfig = {
    clientId: 'NYBUgwT6jF0KUatOUYvTmdOM5bbULxLr6DfaakZ2',
    clientSecret: 'goUhpw8RFxcJP6PWit42QDfoobmQopJvYohG47InJm6xvegjEasJKpVnfBlAp0F5AEfp9BcqtieJRpCWBZJzD2p9OJSPaGbXaU0Q2z9ewB44EUEfY6ZXLGCcZp4QG7yy',
    redirectUri: 'https://lake.psu.ac.th/api/loginOpenID',
    authEndpoint: 'https://psusso.psu.ac.th:8443/application/o/authorize/',
    tokenEndpoint: 'https://psusso.psu.ac.th:8443/application/o/diis-datalake/token',
};
